import {
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';


@Component({
  selector: 'lps-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss']
})

export class IconComponent implements OnInit {

  @Input() color = '#2a2a2a';
  @Input() icon: string;
  @Input() size = 'auto';
  patch: string;
  @ViewChild('imgRef') imgRef: ElementRef<HTMLImageElement>;

  public className: string;

  ngOnInit() {
    this.loadComponent();
    this.className = 'icon--' + this.size;
  }

  loadComponent() {
    this.patch = `assets/icons-prt/${this.icon}.svg`;
  }
}
